module.exports = __webpack_public_path__ + "img/ios-more.fe804481.svg";